module.exports = __webpack_public_path__ + "static/media/gamesPlayed_500000_1000000.df2b3a32.png";